import {AsyncPipe} from "@angular/common";
import {HttpResponse} from "@angular/common/http";
import {Component, inject, OnInit, ViewChild} from '@angular/core';
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {MatBadge} from "@angular/material/badge";
import {MatButton, MatButtonModule, MatIconButton, MatMiniFabButton} from "@angular/material/button";
import {MatOption} from "@angular/material/core";
import {MatFormField, MatFormFieldModule, MatLabel} from "@angular/material/form-field";
import {MatIcon, MatIconModule} from "@angular/material/icon";
import {MatListModule} from "@angular/material/list";
import {MatSelect} from "@angular/material/select";
import {MatSidenav} from "@angular/material/sidenav";
import {MatTooltip} from "@angular/material/tooltip";
import {LeasePos} from "@features/leasing/lease-pos/lease-pos.model";
import {LoadingService} from "@ui-kit/utils/service/loading.service";
import {SnackbarService} from "@ui-kit/utils/service/snackbar.service";
import {CrudTableComponent} from "@ui-webkit/components/crud-table/crud-table.component";
import {LeasePosService} from "./lease-pos.service";

@Component({
  selector: 'app-lease-pos',
  standalone: true,
  imports: [
    CrudTableComponent,
    MatListModule,
    ReactiveFormsModule,
    MatBadge,
    AsyncPipe,
    MatFormFieldModule,
    MatOption,
    MatSelect,
    MatIconModule,
    MatButtonModule,
    MatTooltip,
  ],
  templateUrl: './lease-pos.component.html',
  styleUrl: './lease-pos.component.scss'
})
export class LeasePosComponent implements OnInit {
  private _loader = inject(LoadingService);
  private _snackBarService = inject(SnackbarService)
  protected loading$ = this._loader.loading$;

  leasePosList: LeasePos[] = [];
  selectedPos: LeasePos | null = null;

  selectedDataTypes: FormControl<string[] | null>;

  dataTypes: { label: string, value: string, default: boolean }[] = [
    {label: 'Customers', value: 'customers', default: true},
    {label: 'Inventory', value: 'inventory', default: true},
    {label: 'Product Types', value: 'product_types', default: true},
    {label: 'Products', value: 'products', default: true},
    {label: 'Registers', value: 'registers', default: true},
    {label: 'Sales', value: 'sales', default: true},
    {label: 'Suppliers', value: 'suppliers', default: true},
    {label: 'Users', value: 'users', default: true},
    {label: 'Consignments', value: 'consignments', default: false},
    {label: 'Customer Groups', value: 'customer_groups', default: false},
    {label: 'Brands', value: 'brands', default: false},
    {label: 'Channel Requests', value: 'channel_requests', default: false},
    {label: 'Outlet Taxes', value: 'outlet_taxes', default: false},
    {label: 'Outlets', value: 'outlets', default: false},
    {label: 'Payment Types', value: 'payment_types', default: false},
    {label: 'Price Book Products', value: 'price_book_products', default: false},
    {label: 'Price Books', value: 'price_books', default: false},
    {label: 'Product Categories', value: 'product_categories', default: false},
    {label: 'Promotions', value: 'promotions', default: false},
    {label: 'Quotes', value: 'quotes', default: false},
    {label: 'Retailer', value: 'retailer', default: false},
    {label: 'Serial Numbers', value: 'serialnumbers', default: false},
    {label: 'Services', value: 'services', default: false},
    {label: 'Tags', value: 'tags', default: false},
    {label: 'Taxes', value: 'taxes', default: false},
    {label: 'Variant Attributes', value: 'variant_attributes', default: false},
    {label: 'Shifts', value: 'shifts', default: false},
    {label: 'Audit Log Events', value: 'auditlog_events', default: false},
    {label: 'Gift Cards', value: 'gift_cards', default: false},
    {label: 'Store Credits', value: 'store_credits', default: false},
  ]

  protected readonly leasePosModel = LeasePos;

  constructor(private leasePosService: LeasePosService) {
    this.selectedDataTypes = new FormControl(
      this.dataTypes.filter(f => f.default).map(m => m.value)
    );
  }

  ngOnInit() {
    this.loadLeasePosData();
  }

  loadLeasePosData() {
    this.leasePosService.getLeasePosData().subscribe({
      next: data => {
        this.leasePosList = data;
      },
      error: error => {
        console.log(error);
      }
    })
  }

  downloadVendData() {
    if (this.selectedPos && this.selectedDataTypes) {
      const request = {
        config: this.selectedPos,
        dataTypes: this.selectedDataTypes.value!
      }

      this.leasePosService.downloadPosDataForConfig(request).subscribe({
        next: (data: HttpResponse<ArrayBuffer>) => {
          const contentDisposition = data.headers.get('Content-Disposition');
          let filename = 'download.zip';

          if (contentDisposition) {
            filename = contentDisposition.replace('attachment;filename=', '').trim();
          }

          const blob = new Blob([data!.body!], {type: 'application/octet-stream'});
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);

          this._snackBarService.openSnackBar(`Successfully downloaded POS data for selected config`);
        },
        error: error => {
          console.log(error);
          this._snackBarService.openSnackBar(`Failed to download POS data for selected config`);
        }
      })
    }
  }

  rowSelected($event: any) {
    this.selectedPos = $event
  }
}
